module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.04cace7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/title-banner1-type3.png
// module id = z59u
// module chunks = 1